<app-detail-card
  [isLoading]="isLoading"
  [title]="getCardTitle()"
  [image]="'assets/img/personnel.png'"
  [canUploadImage]="false"
  [contentToShow]="mode == getModes().NEW ? DetailCardContent.EMPTY : DetailCardContent.TABS"
  [tabs]="[
    { name: 'Field services', content: fieldServices },
    { name: 'Skills', content: skills }
  ]"
>

  <!-- Sidebar -->
  <div class="form" sidebar-content>

    <!-- General information -->
    <div class="group-title">{{ 'General information' | translate }}</div>
    <form #form class="group">

      <!-- First name -->
      <mat-form-field>
        <mat-label>{{ 'First name' | translate }}</mat-label>
        <input matInput [(ngModel)]="person.firstName" [ngModelOptions]="{standalone: true}" required>
      </mat-form-field>

      <!-- Last name -->
      <mat-form-field>
        <mat-label>{{ 'Last name' | translate }}</mat-label>
        <input matInput [(ngModel)]="person.lastName" [ngModelOptions]="{standalone: true}" required>
      </mat-form-field>

      <!-- Email -->
      <mat-form-field>
        <mat-label>{{ 'Email' | translate }}</mat-label>
        <input matInput type="email" [(ngModel)]="person.email" [ngModelOptions]="{standalone: true}" required [disabled]="mode == CreationMode.UPDATE">
      </mat-form-field>

      <!-- Phone -->
      <div class="row">
        <mat-form-field style="width: 75px">
          <mat-label>{{ 'Prefix' | translate }}</mat-label>
          <input matInput [(ngModel)]="person.prefix" pattern="\+[0-9]+" [ngModelOptions]="{standalone: true}" required>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'Phone' | translate }}</mat-label>
          <input matInput [(ngModel)]="person.phoneNumber" pattern="[0-9]+" [ngModelOptions]="{standalone: true}" required>
        </mat-form-field>
      </div>

      <!-- Password -->
      <ng-container *ngIf="environment.authProvider == 'parse'">
        <mat-form-field>
          <mat-label>{{ 'Password' | translate }}</mat-label>
          <input #password matInput type="password" [(ngModel)]="person.password" [ngModelOptions]="{standalone: true}" [required]="mode == getModes().NEW" minlength="8">
          <mat-error *ngIf="password.value.length < 8">
            {{ 'Choose a password with at least 8 characters' | translate }}
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ '' | translate }}Repeat password</mat-label>
          <input #repeatPassword matInput type="password" ngModel [pattern]="person.password" [ngModelOptions]="{standalone: true}" [required]="mode == getModes().NEW || password.value.length > 0" minlength="8">
          <mat-error *ngIf="repeatPassword.value.length < 8">
            {{ 'Choose a password with at least 8 characters' | translate }}
          </mat-error>
          <mat-error *ngIf="password.value != repeatPassword.value">
            {{ 'Passwords do not match' | translate }}
          </mat-error>
        </mat-form-field>
      </ng-container>

      <!-- Roles -->
      <div class="group-title">{{ 'Roles' | translate }}</div>
      <div class="group">
        <mat-checkbox *ngFor="let role of allRoles" color="primary" [checked]="activeRoles.includes(role)" [disabled]="disabledRoles.includes(role)" (change)="updateRole(role, $event.checked)">{{RoleLocalization[role]}}</mat-checkbox>
      </div>

    </form>

  </div>


  <!-- Sidebar actions -->
  <ng-container sidebar-actions>
    <div *ngIf="mode == getModes().NEW" class="col">
      <button mat-raised-button color="primary" (click)="save()" [disabled]="!person.validate() || !form.checkValidity()">{{ 'Create personnel' | translate }}</button>
      <div *ngIf="environment.authProvider != 'parse'" class="creation-email-info">
        <mat-icon>info</mat-icon>
        <div>{{ 'A password reset email will be sent to the user' | translate }}</div>
      </div>
    </div>
    <button *ngIf="mode == getModes().UPDATE" mat-raised-button color="primary" (click)="save()" [disabled]="!person.validate() || !form.checkValidity()">{{ 'Save personnel' | translate }}</button>
    <button *ngIf="mode == getModes().UPDATE" mat-raised-button color="warn" (click)="delete()">{{ 'Remove personnel' | translate }}</button>
  </ng-container>


  <!-- Empty statement on new item -->
  <ng-container empty-statement>
    {{ 'Create a new personnel to start adding field services and skills' | translate }}
  </ng-container>


  <!-- Field services -->
  <ng-template #fieldServices>

    <!-- Header -->
    <div class="header">

      <!-- Search bar -->
      <app-search-bar *ngIf="!environment.production" placeholder="Search field service..." (textSubmit)="filterFieldService($event)"></app-search-bar>

      <div class="spacer"></div>

      <!-- Actions -->
      <div class="actions">
        <button mat-stroked-button color="primary" (click)="bindNewFieldService()">
          <mat-icon>add</mat-icon> {{ 'Bind new field service' | translate }}
        </button>
      </div>

    </div>

    <!-- Field services list -->
    <app-table
      [columns]="getFieldServicesTableColumns()"
      [rows]="getFieldServicesTableData()"
      [paginator]="paginatorSkills"
      (onItemClicked)="showFieldService($event)"
    ></app-table>

  </ng-template>


  <!-- Skills -->
  <ng-template #skills>

    <!-- Header -->
    <div class="header">

      <!-- Search bar -->
      <app-search-bar *ngIf="!environment.production" placeholder="Search skill..." (textSubmit)="filterFieldService($event)"></app-search-bar>

      <div class="spacer"></div>

      <!-- Actions -->
      <div class="actions">
        <button mat-stroked-button color="primary" (click)="bindNewSkill()">
          <mat-icon>add</mat-icon> {{ 'Bind new skill' | translate }}
        </button>
      </div>

    </div>

    <!-- Field services list -->
    <app-table
      [columns]="getSkillsTableColumns()"
      [rows]="getSkillsTableData()"
      [paginator]="paginatorSkills"
      (onItemClicked)="showSkill($event)"
    ></app-table>

  </ng-template>


</app-detail-card>
